import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { removeDiacritics } from '../../../../util/string.util';
import Icon, { IconType } from '../../../icons/Icon';
import TextInput from '../TextInput';

interface SearchbarProps {
  value: string;
  onChange: (query: string) => void;
  placeholder?: string;
  clearable?: boolean;
}

export default function Searchbar({ value, onChange, placeholder, clearable = false }: SearchbarProps) {
  return (
    <TextInput
      className='w-[400px]'
      value={value}
      placeholder={placeholder || t(TranslationKey.search).singular.upper}
      leading={<Icon type={IconType.searchLg} size={'h-4 w-4'} />}
      onChange={value => onChange(removeDiacritics(value))}
      trailing={clearable && value && <Icon type={IconType.x} size={'h-5 w-'} onClick={() => onChange('')} />}
    />
  );
}
